import { __assign } from "tslib";
// DS: C35
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MobileSubmissionDetails from './MobileSubmissionDetails';
import DesktopSubmissionDetails from './DesktopSubmissionDetails';
var SubmissionDetails = function (props) {
    var isMobile = useContext(MobileContext);
    return isMobile ? (React.createElement(MobileSubmissionDetails, __assign({}, props))) : (React.createElement(DesktopSubmissionDetails, __assign({}, props)));
};
SubmissionDetails.displayName = 'SubmissionDetails';
export default SubmissionDetails;
//# sourceMappingURL=SubmissionDetails.js.map